import { render, staticRenderFns } from "./AssignProducers.vue?vue&type=template&id=59377092&"
import script from "./AssignProducers.vue?vue&type=script&lang=js&"
export * from "./AssignProducers.vue?vue&type=script&lang=js&"
import style0 from "./AssignProducers.vue?vue&type=style&index=0&id=59377092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports